(function () {
  'use strict';
 
  document.addEventListener('DOMContentLoaded', function () {
    var EXTRA_OFFSET = 20; // zusätzlicher Puffer in px, nach Geschmack anpassen
 
    function getHeaderOffset() {
      // Trade-Theme (Maestrooo) setzt meist --header-height als CSS-Variable auf <html> oder <body>
      var cssVar = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
      var headerHeight = parseInt(cssVar, 10);
 
      if (!headerHeight) {
        // Fallback: tatsächliche Höhe des (sticky) Headers messen
        var header = document.querySelector(
          '.site-header, header.shopify-section-header, #shopify-section-header, .header-wrapper, .header'
        );
        headerHeight = header ? header.offsetHeight : 0;
      }
      return headerHeight + EXTRA_OFFSET;
    }
 
    function scrollToTarget(target) {
      var targetPosition = target.getBoundingClientRect().top + window.pageYOffset - getHeaderOffset();
      window.scrollTo({ top: targetPosition, behavior: 'smooth' });
    }
 
    // Klicks auf die Menü-Links abfangen
    document.querySelectorAll('a.jump-link').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var targetId = link.getAttribute('href');
        if (!targetId || targetId.charAt(0) !== '#') return;
 
        var target = document.querySelector(targetId);
        if (!target) return;
 
        e.preventDefault();
        scrollToTarget(target);
 
        if (history.pushState) {
          history.pushState(null, null, targetId);
        }
      });
    });
 
    // Falls die Seite direkt mit einem #anchor in der URL aufgerufen wird
    // (z. B. Link von aussen auf .../versand-und-zahlung#ziel-eu),
    // ebenfalls mit Header-Offset scrollen statt Browser-Standardverhalten.
    if (window.location.hash) {
      var initialTarget = document.querySelector(window.location.hash);
      if (initialTarget) {
        // Kurzes Timeout, damit das Theme (Sticky Header, Lazy-Loading etc.)
        // erst fertig gerendert hat, bevor gescrollt wird.
        window.setTimeout(function () {
          scrollToTarget(initialTarget);
        }, 150);
      }
    }
  });
})();